import MotivationalQuotesUtil from '../utils/MotivationalQuotesUtil'
import {FC, useEffect, useState} from 'react'
import {Button, Card, Empty, Flex, Modal, Skeleton, Tag, Typography} from 'antd'
import {ID, WordList} from '../../shared/types/api'
import {goToExercisePageWithReloading} from '../utils/goToPage'
import {NavigationPages} from '../../common/navigation/navigation-pages'
import {useNavigate} from 'react-router-dom'
import useCardRepeatCardLists from '../../hooks/useCardRepeatCardLists'
import Pages from '../../const/Pages'
import CardImageUtils from "../utils/CardImageUtils";
import {Player} from "@lottiefiles/react-lottie-player";
import Constants from "../../const/Constants";
import {Image} from 'antd';
import {updateWordListRoutine} from "../../store/wordLists";
import {useAppDispatch} from "../../store/hooks";
import RepeatSuggestion from "../blocks/repeat-suggestion/RepeatSuggestion";
import TreeWatering from "../blocks/tree-watering/TreeWatering";

const {Text} = Typography;

interface CompletedExerciseDialogProps {
    selectedWordList: WordList | undefined;
    close: () => void;
    open: boolean
}

const CompletedExerciseDialog: FC<CompletedExerciseDialogProps> = ({
                                                                       close,
                                                                       open,
                                                                       selectedWordList
                                                                   }) => {

    const navigate = useNavigate()
    const dispatch = useAppDispatch()


    const deadImage = CardImageUtils.getCardImage(selectedWordList?.tree);
    const wateredImage = CardImageUtils.getCardWateredImage(selectedWordList?.tree);

    const [currentImage, setCurrentImage] = useState(deadImage);
    const [watering, setWatering] = useState(false);
    const [quote, setQuote] = useState<string>('');

    useEffect(() => {
        if (!open) return;
        setQuote(MotivationalQuotesUtil.generateRandomMotivationQuote());
        setCurrentImage(deadImage);
        setWatering(true);

        const timer = setTimeout(() => {
            setCurrentImage(wateredImage);
            setWatering(false);
        }, 1200);

        return () => clearTimeout(timer);
    }, [open]);

    const updateTreeStatus = (
        wordList: WordList | undefined,
        status: string
    ): WordList | undefined => {
        if (!wordList || !wordList.tree) return wordList;

        return {
            ...wordList,
            tree: {
                ...wordList.tree,
                status
            }
        };
    };


    const {repeatSuggestion, isLoading} = useCardRepeatCardLists(Pages.CARD, open, selectedWordList?.id)

    const clearAndClose = () => {
        setTimeout(() => {
            const wordList = updateTreeStatus(selectedWordList, Constants.TREE_STATUSES[0])
            dispatch(updateWordListRoutine(wordList))
        }, 500);
        close()
    }

    const openSuggestionList = (rs: WordList) => {
        clearAndClose()
        goToExercisePageWithReloading(NavigationPages.CARDS, navigate, rs)
    }

    return (
        <Modal
            title={'Молодец! Все карточки в списке пройдены!'}
            onCancel={clearAndClose}
            footer={[
                <Button danger onClick={clearAndClose}>
                    Закрыть
                </Button>
            ]}
            open={open}>
            <div>
                <span>{quote}</span>
            </div>
            <Text type="secondary">
                Прогресс складывается из маленьких шагов.
                Зайдите завтра всего на 5 минут, чтобы закрепить результат.
            </Text>
            <TreeWatering selectedWordList={selectedWordList}
                          currentImage={currentImage}
                          watering={watering}/>


            <RepeatSuggestion isLoading={isLoading} repeatSuggestion={repeatSuggestion}
                              openSuggestionList={openSuggestionList}
                              clearAndClose={clearAndClose}/>
        </Modal>
    )
}

export default CompletedExerciseDialog